import { NgModule } from '@angular/core';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { RegisterAsComponent } from './register-as.component';
import { IframeExternalLoginModule } from 'components/iframe-external-login/iframe-external-login.module';
import { ExternalServicesIconsModule } from 'components/external-services-icons/external-services-icons.module';
import { SelectModule } from '@certemy/ui-components';

@NgModule({
  imports: [
    CertemyCommonModule,
    InlineErrorModule,
    IframeExternalLoginModule,
    ExternalServicesIconsModule,
    SelectModule,
  ],
  declarations: [RegisterAsComponent],
  exports: [RegisterAsComponent],
})
export class RegisterAsModule {}
